import React from 'react';
import Signin from '../Components/Signin';
import ScrollToTop from '../Components/ScrollToTop';

const SigninPage = () => {
    return (
        <>
            <ScrollToTop />
            <Signin />
        </>
    )
}

export default SigninPage;
